import './css/app.css';
import 'utils/lazysizes';
import { picoapp } from 'picoapp';
import ready from 'utils/ready';

// Layout
import cartDrawer from 'layout/cart-drawer';
import cartDrawerUpsell from 'layout/cart-drawer-upsell';
import country from 'layout/country';
import header from 'layout/header';
import liveSearch from 'layout/live-search';
import mobileMenu from 'layout/mobile-menu';
import stories from 'layout/stories';
import topbar from 'layout/topbar';
import zendesk from 'layout/zendesk';
import sizeDrawer from 'layout/size-drawer';

// Components
import breadcrumbs from 'components/breadcrumbs';
import cartItem from 'components/cart-item';
import featureSingle from 'components/feature-single';
import flagIcons from 'components/flag-icons';
import foldOut from 'components/fold-out';
import newsletter from 'components/newsletter';
import productSlider from 'components/product-slider';
import quiz from 'components/quiz';
import quickbuyItem from 'components/quickbuy-item';
import responsiveVideo from 'components/responsive-video';

const app = picoapp({
  breadcrumbs,
  cartDrawer,
  cartDrawerUpsell,
  country,
  cartItem,
  featureSingle,
  flagIcons,
  foldOut,
  header,
  liveSearch,
  mobileMenu,
  newsletter,
  productSlider,
  quiz,
  quickbuyItem,
  responsiveVideo,
  stories,
  topbar,
  zendesk,
  sizeDrawer,
}, {
  cart: theme.cart,
});

ready(app.mount);

document.addEventListener('app:mount', () => app.mount());

export default app;
